<template lang="pug">
.modal.doNotDesactiveOnClick(ref="modal")
  .modal-dialog(v-if='sharedObject')
    .modal-content
      .modal-body(v-if='error')
        .alert.alert-danger
          i.fa.fa-exclamation
          |  {{$t('globals.error')}}
      .modal-body(v-else-if='sharedObject && sharedObject.loading')
        i.fa.fa-refresh.fa-spin
        |  {{$t('globals.loading')}}
      template(v-else)
        .modal-header
          template(v-if='sharedObject && !sharedObject.loading')
            shared-object-abstract(:sharedObject='sharedObject', @click='openSharedObject', role='button')
        .modal-body
          template(v-if='sharedObject')
            .alert.alert-danger(v-if='sharedObject.permissions && !sharedObject.permissions.EDIT') {{$t('sharedObjectMembers.noSuffisantRight')}}
            .alert.alert-info(v-else) {{$t('sharedObjectMembers.suffisantRight')}} 

            template(v-if='viewersStatus == STATUS.LOADING')
              i.fa.fa-refresh.fa-spin
              |  {{$t('globals.loading')}}
            template(v-else)
              template(v-for='viewer in restrictedViewers')
                .viewer(:class='{restricted: viewer.permissions.restricted, canNotView: !viewer.permissions.canView}', :key='viewer.id', role='button', @click='toggleViewer(viewer)')
                  vue-object-img(:object='viewer')
                  |  {{viewer.name}}
                  i.fa.fa-eye-slash.action(v-if='viewer.permissions.restricted && !viewer.permissions.canView')
                  i.fa.fa-eye.action(v-if='viewer.permissions.restricted && viewer.permissions.canView')
              auto-complete-user.doNotDesactiveOnClick(v-if='sharedObject.permissions && sharedObject.permissions.EDIT', showGroops="none", showUsers="all", placeholder="Entrez le nom ou l'email d'une personne pour l'ajouter", @select="addRestrictedUser", :acceptNewUser='true', :acceptNewGroop='false', :container='$refs.modal.getElementsByClassName("modal-body")[0]', ref='autoCompleteUser')
              hr
              .text-center
                a(@click="toggleShowNonRestricted", role='button') {{$tc('sharedObjectMembers.otherViewers', nonRestrictedViewers.length, {nb: nonRestrictedViewers.length})}}
              template(v-if='showNonRestricted')
                .alert.alert-info {{$t('sharedObjectMembers.otherViewersDescription')}}
                template(v-if='viewersStatus == STATUS.LOADING')
                  i.fa.fa-refresh.fa-spin
                  |  {{$t('globals.loading')}}
                template(v-for='viewer in nonRestrictedViewers')
                  .viewer(:key='viewer.id')
                    vue-object-img(:object='viewer')
                    |  {{viewer.name}}


</template>
<script type="text/javascript">
import swal from 'sweetalert2'
import SharedObjectAbstract from '@/components/shared/SharedObjectAbstract'
import AutoCompleteUser from '@/components/shared/AutoCompleteUser'

import modalsBus from '@/components/shared/ModalsBus'

import _ from 'lodash'
import $ from 'jquery'

import VueObjectImg from '@/components/shared/VueObjectImg'
import STATUS from '@/utils/status'

import api from '@/utils/api'
import Vue from 'vue'

export default {
  data () {
    return {
      sharedObject: null,
      unwatch: null,
      open: false,
      error: false,
      showNonRestricted: false,
      STATUS
    }
  },
  components: {
    SharedObjectAbstract,
    VueObjectImg,
    AutoCompleteUser
  },
  mounted () {
    this.checkOpenModalFromRouteQuery()
    modalsBus.onOpen((arg, object) => {
      if (arg === modalsBus.modals.MANAGE_RESTRICTED_VIEWERS) {
        this.setSharedObject(object)
        this.openModal()
      } else {
        if (arg !== modalsBus.modals.EDIT_ANSWER) {
          this.closeModal()
        }
      }
    })
    modalsBus.onCloseAll(() => {
      this.closeModal()
    })
    $(this.$refs.modal).on('hidden.bs.modal', () => {
      this.closeModal()
    })
  },
  computed: {
    viewers () {
      return (this.sharedObject.viewers && this.sharedObject.viewers.data) || []
    },
    restrictedViewers () {
      return (this.sharedObject.viewers && this.sharedObject.viewers.data.filter((r) => r.permissions.restricted)) || []
    },
    nonRestrictedViewers () {
      return (this.sharedObject.viewers && this.sharedObject.viewers.data.filter((r) => !r.permissions.restricted)) || []
    },
    viewersStatus () {
      return (this.sharedObject.viewers && this.sharedObject.viewers.status) || STATUS.LOADING
    }
  },
  methods: {
    openModal () {
      if (this.open) {
        return
      }
      this.open = true
      this.error = false
      this.showNonRestricted = false
      $(this.$refs.modal).modal('show')
      if (this.$route.query.m !== 'share') {
        this.prevQuery = this.$route.query
      } else {
        this.prevQuery = {}
      }
      if (this.sharedObject.kind !== 'deleted') {
        this.$router.push({query: _.merge({m: 'share', k: this.sharedObject.kind, i: this.sharedObject.id}, this.prevQuery)})
      }
      this.unwatch = this.$watch('sharedObject', () => {
        if (this.sharedObject.kind !== 'deleted') {
          this.$router.push({query: _.merge({m: 'share', k: this.sharedObject.kind, i: this.sharedObject.id}, this.prevQuery)})
        }
      })
      // this.installKeyshorts()
      this.$nextTick(() => {
        if (this.$refs.contents) {
          this.$refs.contents.scrollTop = 0
        }
      })
    },
    closeModal () {
      if (!this.open) {
        return
      }
      this.open = false
      $(this.$refs.modal).modal('hide')
      this.$router.push({query: this.prevQuery})
      // MousetrapManager.unbindLabel('SharedObjectViewer')
      this.setSharedObject(null)
      if (this.unwatch) {
        this.unwatch()
      }
    },
    setSharedObject (object) {
      this.sharedObject = object
      if (this.sharedObject && (this.sharedObject.loading || !this.sharedObject.viewers)) {
        let promise = this.$store.dispatch('sharedObjects/loadSharedObject', {
          kind: this.sharedObject.kind,
          id: this.sharedObject.id,
          viewers: true
        })
        if (!promise) {
          this.setError()
        } else {
          promise.then((object) => {
            for (let k in object) {
              let v = object[k]
              if (v !== this.sharedObject[k] && k !== 'id') {
                Vue.set(this.sharedObject, k, v)
              }
            }
            this.sharedObject.loading = false
          }).catch(() => {
            this.setError()
          })
        }
      }
    },
    openSharedObject () {
      let so = this.sharedObject
      this.closeModal()
      modalsBus.open(modalsBus.modals.OPEN_SHARED_OBJECT, so)
    },
    toggleShowNonRestricted () {
      this.showNonRestricted = !this.showNonRestricted
    },
    checkOpenModalFromRouteQuery () {
      let kind = this.$route.query.k
      let id = parseInt(this.$route.query.i)
      if (this.$route.query.m === 'share') {
        if (this.sharedObject && kind === this.sharedObject.kind && id === this.sharedObject.id) {
          // console.log('shared')
          // this.openModal()
          return
        }
        this.setSharedObject({
          kind: kind,
          id: id,
          loading: true
        })
        this.openModal()
      } else {
        this.closeModal()
      }
    },
    toggleViewer (viewer) {
      if (this.sharedObject.permissions && !this.sharedObject.permissions.EDIT) {
        return
      }
      viewer.permissions.canView = !viewer.permissions.canView
      if (viewer.permissions.canView) {
        api.post('/sharedObjectViewer/' + this.sharedObject.kind + '/' + this.sharedObject.id, {
          userId: viewer.id
        }).then(() => { Vue.set(this.sharedObject, 'fullView', false) })
      } else {
        api.delete('/sharedObjectViewer/' + this.sharedObject.kind + '/' + this.sharedObject.id, {
          data: {
            userId: viewer.id
          }
        }).then(() => { Vue.set(this.sharedObject, 'fullView', false) })
      }
    },
    setError () {
      this.error = true
    },
    addRestrictedUser (element) {
      element.role = 'Remplacant'
      if (this.$refs.autoCompleteUser.isNewUser(element)) {
        let promises = []
        if (/\S+@\S+\.\S+/.test(element.name)) { // email
          promises.push(swal({
            title: 'Entrez un nom pour ce nouveau membre',
            input: 'text',
            inputPlaceholder: 'Le nom complet de ce membre (ex: Paul Durant)',
            showCancelButton: true,
            cancelButtonText: this.$i18n.t('globals.cancel'),
            confirmButtonText: 'Créer ce membre'
          }).then((result) => {
            element.name = result
          }))
        } else {
          promises.push(swal({
            title: 'Entrez un email pour ce nouveau membre',
            input: 'text',
            inputPlaceholder: 'L\'email de ce membre (ex: paul.durant@gmail.com)',
            showCancelButton: true,
            cancelButtonText: this.$i18n.t('globals.cancel'),
            confirmButtonText: 'Créer ce membre'
          }).then((result) => {
            element.email = result
          }))
        }
        Promise.all(promises).then(() => {
          api.post(`group/${this.sharedObject.group.id}/members`,
            {
              infos: [element],
              defaultLg: this.$i18n.locale,
              invitationText: this.$i18n.t('groups.createMembersModal.fields.invitationText.defaultText')
            }).then(response => {
              let memberInfo = response.data.members[0]
              memberInfo.permissions = {canView: false, restricted: true}
              this.sharedObject.viewers.data.push(memberInfo)
              this.toggleViewer(memberInfo)
              console.log('saved')
            }).catch(response => {
              console.log('error')
            })
        })
      } else {
        api.post(`group/${this.sharedObject.group.id}/members`,
          {
            infos: [element],
            defaultLg: this.$i18n.locale,
            invitationText: this.$i18n.t('groups.createMembersModal.fields.invitationText.defaultText')
          }).then(response => {
            let memberInfo = response.data.members[0]
            memberInfo.permissions = {canView: false, restricted: true}
            this.sharedObject.viewers.data.push(memberInfo)
            this.toggleViewer(memberInfo)
            console.log('saved')
          }).catch(response => {
            console.log('error')
          })
      }
    }
  },
  watch: {
    $route () {
      this.checkOpenModalFromRouteQuery()
    }
  }
}
</script>
<style lang="sass">
.viewer
  padding: 10px 5px
  margin-bottom: 1px
  border-radius: 5px
  &.restricted
    &.canNotView
      opacity: 0.3
    &:hover
      background-color: #bce8f1
      opacity: 1
    &:hover:not(.canNotView)
      background-color: rgb(148, 223, 134)
    .action
      float: right
      margin-top: 5px
      margin-right: 5px
    &:not(:hover):not(.canNotView)
      background-color: rgb(148, 223, 134)
  .profileImage
    $size: 30px
    height: $size
    width: $size
    line-height: $size
</style>



// WEBPACK FOOTER //
// SharedObjectMembers.vue?c8b239d6